import React from 'react';
import { createArray } from '../_utils';
var ListSkeleton = function (props) {
    var _a = props.count, count = _a === void 0 ? 3 : _a, _b = props.small, small = _b === void 0 ? false : _b;
    return (React.createElement("ul", { className: "list-group" }, createArray(count).map(function (_, i) { return (React.createElement("li", { className: "list-group-item d-flex justify-content-between align-items-center " + (!!small && 'py-2') },
        React.createElement("span", { key: i, className: "skeleton-line h-100 w-100" }))); })));
};
export default React.memo(ListSkeleton);
